import { InvitationStatusEnum } from '@seaters-app/constants';

export const statusesToCancel = [
  InvitationStatusEnum.BEING_REVIEWED,
  InvitationStatusEnum.DEMAND_ACCEPTED,
];

export const statusesToAccept = [InvitationStatusEnum.RSVP_TO_ACCEPT];
export const statusesToTickets = [InvitationStatusEnum.RSVP_CONFIRMED];
